'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _DayPicker = require('./DayPicker');

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _TodayPicker = require('./TodayPicker');

var _TodayPicker2 = _interopRequireDefault(_TodayPicker);

var _Calendar = require('./Calendar.scss');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = function (_React$Component) {
  (0, _inherits3.default)(Calendar, _React$Component);

  function Calendar() {
    (0, _classCallCheck3.default)(this, Calendar);
    return (0, _possibleConstructorReturn3.default)(this, (Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Calendar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: (0, _classnames2.default)(this.props.className, _Calendar2.default.calendar), style: this.props.style,
          onMouseDown: this.props.onMouseDown,
          onMouseUp: this.props.onMouseUp,
          ref: function ref(div) {
            return _this2.div = div;
          } },
        _react2.default.createElement(_Header2.default, { value: this.props.value, monthName: this.props.monthName, leftArrow: this.props.leftArrow,
          rightArrow: this.props.rightArrow, onChange: this.props.onChange, onClick: this.props.onHeaderClick }),
        _react2.default.createElement(_DayPicker2.default, { value: this.props.value, onChange: this.props.onChange, daysOfTheWeek: this.props.daysOfTheWeek, isDateTime: this.props.isDateTime }),
        _react2.default.createElement(_TodayPicker2.default, { onChange: this.props.onChange, value: this.props.localToday, isDateTime: this.props.isDateTime })
      );
    }
  }]);
  return Calendar;
}(_react2.default.Component);

;

Calendar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
  value: _propTypes2.default.instanceOf(_moment2.default),
  /**
   * An array of localized months
   */
  monthName: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /**
   * The localized version of the word today
   */
  localToday: _propTypes2.default.string,
  /**
   * A function to handle updating the text field should at least update the value
   */
  onChange: _propTypes2.default.func,
  /**
   * url for the left arrow image
   */
  leftArrow: _propTypes2.default.string,
  /**
   * url for the right arrow image
   */
  rightArrow: _propTypes2.default.string,
  /**
   * A function responsible for handling the arrow clicks in the header
   */
  onHeaderClick: _propTypes2.default.func,
  /**
   * A function to handle mouse down events, useful for tracking when someone clicks off the calendar
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * A function to handle the mouse up event, useful for tracking when someone clicks off the calendar
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object
};

Calendar.defaultProps = {
  leftArrow: _IconPath2.default.get('Action_Back'),
  rightArrow: _IconPath2.default.get('Action_Forward')
};

exports.default = Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/Calendar.js
// module id = 825
// module chunks = 10